"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _messageTemplate = require('shared/actions/messageTemplate'); var _messageTemplate2 = _interopRequireDefault(_messageTemplate);
var _templateLatest = require('shared/services/templateLatest');
var _peers = require('shared/selectors/peers');
var _typed = require('shared/hooks/typed');

// A fetch faster than this shows no loading state at all.
const SLOW_FETCH_MS = 300

// "Jo Rivera" → "Jo R.".
const shortName = (name) => {
  const [first, ...rest] = name.trim().split(/\s+/)
  const last = rest[rest.length - 1]
  return last ? `${first} ${last[0].toUpperCase()}.` : _nullishCoalesce(first, () => ( ''))
}







/* Before a template goes in, its latest version is fetched: a teammate may
 * have just edited or deleted it. Used by the "/" list and the Templates
 * dialog. `fetching` names the template while that runs (slow past
 * SLOW_FETCH_MS); `gone` says why a pick didn't go in. */
 const useLatestTemplate = (orgKey) => {
  const [fetching, setFetching] = _react.useState(null)
  const [gone, setGone] = _react.useState(null)
  const users = _typed.useAppSelector.call(void 0, _peers.selectAllUsers)
  const live = _react.useRef.call(void 0, true)
  _react.useEffect.call(void 0, () => {
    live.current = true
    return () => { live.current = false }
  }, [])
  const busy = _react.useRef.call(void 0, false)

  const updatedNotice = _react.useCallback.call(void 0, (template) => {
    const name = _optionalChain([users, 'optionalAccess', _ => _[template.UpdatedBy ], 'optionalAccess', _2 => _2.Name])
    return name ? `Updated by ${shortName(name)} just now` : 'Updated just now'
  }, [users])

  /* The latest version, or null when it's gone (deleted, no longer shared),
   * the component went away, or another fetch is still running. */
  const latest = _react.useCallback.call(void 0, async (shown) => {
    if (busy.current) return null
    busy.current = true
    setGone(null)
    setFetching({ key: shown.TemplateKey, slow: false })
    const slowTimer = setTimeout(() => setFetching(f => f && { ...f, slow: true }), SLOW_FETCH_MS)
    const result = await _templateLatest.fetchLatestTemplate.call(void 0, orgKey, shown)
    clearTimeout(slowTimer)
    busy.current = false
    if (!live.current) return null
    setFetching(null)
    if (result.kind === 'deleted' || result.kind === 'unavailable') {
      setGone(result.kind === 'deleted' ? 'This template was just deleted.' : 'You can no longer use this template.')
      if (result.kind === 'deleted') _messageTemplate2.default.listMessageTemplates(orgKey).catch(() => null)
      return null
    }
    return { template: result.template, notice: result.kind === 'updated' ? updatedNotice(result.template) : undefined }
  }, [orgKey, updatedNotice])

  return { latest, fetching, gone, setGone }
}; exports.useLatestTemplate = useLatestTemplate
